window.onload = function() {
    var targetElement = document.getElementById('appsflyer-buttons');

    if (targetElement) {
        var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        var buttons = document.querySelectorAll('.appsflyer-btn');
        var desktopButtons = document.querySelectorAll('.appsflyer-btn[data-platform="desktop"]');
        var mobileButtons = document.querySelectorAll('.appsflyer-btn[data-platform="mobile"]');
        var desktopHeadlines = document.querySelectorAll('.headline--desktop');
        var mobileHeadlines = document.querySelectorAll('.headline--mobile-tablet');

        // hide buttons/headlines by default
        buttons.forEach(function(button) {
            button.style.display = 'none';
        });

        if (desktopHeadlines.length > 0) {
            desktopHeadlines.forEach(headline => {
                headline.style.display = 'none';
            })
        }

        if (mobileHeadlines.length > 0) {
            mobileHeadlines.forEach(headline => {
                headline.style.display = 'none';
            })
        }

        if (isMobile) {
            mobileButtons.forEach(btn => {
                btn.style.display = 'inline-block';
            });

            if (mobileHeadlines.length > 0) {
                mobileHeadlines.forEach(headline => {
                    headline.style.display = 'block';
                })
            }
        } else {
            desktopButtons.forEach(btn => {
                btn.style.display = 'flex';
            });

            if (desktopHeadlines.length > 0) {
                desktopHeadlines.forEach(headline => {
                    headline.style.display = 'inline-block';
                })
            }
        }

        buttons.forEach(function(button) {
            if (!button.classList.contains('earnify-btn')) {
                button.addEventListener('click', function() {
                    var result_url = AF_SMART_SCRIPT_RESULT.clickURL;
                    if (result_url) {
                        this.setAttribute('href', result_url);
                    }
                });
            }
        });
    }
};

